import { useEffect, useRef, useState } from "react";
import "../styles/SlideShow.css";

const SlideShow = ({ slides }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideInterval = useRef(null);

  // const length = slides.length;
  const length = slides?.length || 0;
  const intervalLength = 6000;
  // let slideInterval;

  // useEffect(() => {
  //   // Prevent crach by checking slides exist
  //   if (!Array.isArray(slides) || length === 0) return;

  //   // Start the slideshow
  //   slideInterval.current = setInterval(() => {
  //     // Loop infinitely through slides
  //     setCurrentSlide((prev) => (prev + 1) % length);
  //   }, intervalLength);

  //   // cleanup function to clear the interval when the component unmounts
  //   return () => clearInterval(slideInterval.current);
  // }, [length, slides]);

  useEffect(() => {
    if (!length) return;

    // Start the slideshow
    slideInterval.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % length);
    }, intervalLength);

    // Cleanup function to clear the interval when the component unmounts
    return () => clearInterval(slideInterval.current);
  }, [length]);

  if (!Array.isArray(slides) || length === 0) return null;

  return (
    <section className="slide__container">
      {slides.map((slide, index) => (
        <img
          key={slide.src}
          src={slide.src}
          alt={slide.alt}
          className={`slide ${index === currentSlide ? "active" : ""}`}
        />
      ))}
    </section>
  );
};

export default SlideShow;
